<template lang="html">
    <div class="monthly-hydrology-table">
        <b-table
            :data="formattedData"
            :is-fullwidth="true"
            :narrowed="true"
        >
            <template slot-scope="props">
                <b-table-column
                    field="rowName"
                    class="row-name"
                >
                    {{ props.row[0] }}
                </b-table-column>
                <b-table-column
                    v-for="(values, key, index) in props.row.slice(1)"
                    :key="index"
                    :field="`month-${key}`"
                    :label="monthNumberToName(key + 1, 'MMM')"
                    :numeric="true"
                    class="month"
                    header-class="month"
                >
                    {{ props.row[key + 1] }}
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>

<script>
import numeral from 'numeral';

import dateUtilsMixin from '../mixins/dateUtilsMixin.js';

export default {
    mixins: [
        dateUtilsMixin,
    ],

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * Format the data provided in the props so that it can be used in the table.
         *
         * @returns {Array} - all rows to be shown in table
         */
        formattedData() {
            const rows = [];

            // Go through all keys in data object
            Object.keys(this.data).forEach((key) => {
                // add key to row, as we want to display it
                const row = [key];

                // add each value to row, formatting any numbers
                this.data[key].forEach((value) => {
                    if (typeof value === 'number') {
                        row.push(numeral(value).format('0,0.00'));
                    } else {
                        row.push(value);
                    }
                });
                rows.push(row);
            });

            return rows;
        },
    },
};
</script>

<style lang="scss">
.monthly-hydrology-table {
    font-size: 0.75em;

    @media screen and (max-width: $desktop) {
        font-size: 0.6em;
    }

    .month {
        width: 5%;

        @media screen and (min-width: $fullhd) {
            width: 6.3%;
        }
    }

    tr:nth-child(2n) {
        td {
            background-color: $color-table-every-second-row;
        }
    }
}
</style>
